import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import store from '../../../../stores/store';
import {
    MTG_UPCOMING,
    MTG_PENDING_TXT,
    MTG_DECLINED,
    MTG_DECLINED_TXT,
    MTG_ATTENDING,
    MTG_ATTENDING_TXT,
    MTG_TENTATIVE,
    MTG_TENTATIVE_TXT,
} from '../../../../helpers/constants';

class Attendance extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
        };
    }

    toggle = () => {
        this.setState({
            expanded: !this.state.expanded,
        });
    };

    changeState = async e => {
        // console.log('AttendanceDropdown changeState', this.props);
        await store.meetings.responseAttendendance(
            Number(this.props.instanceId),
            Number(this.props.groupId),
            Number(this.props.meetingId),
            Number(e),
        );
        if (this.props.onChange) this.props.onChange();
        if (this.props.meetingPanelRerender) this.props.meetingPanelRerender();
    };

    renderDropdown = attendanceText => {
        return (
            <Dropdown dropup isOpen={this.state.expanded} toggle={this.toggle}>
                <DropdownToggle className="btn btn-sm btn-outline-secondary dropdown-toggle " caret>
                    <i className="fa fa-reply pl-2" />
                    <span className="pl-3">{attendanceText}</span>
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem onClick={this.changeState.bind(this, '1')}>
                        <i className="fa fa-check attendee-response-icon-padding" />
                        {MTG_ATTENDING_TXT}
                    </DropdownItem>
                    <DropdownItem onClick={this.changeState.bind(this, '2')}>
                        <i className="fa fa-question attendee-response-icon-padding" />
                        {MTG_TENTATIVE_TXT}
                    </DropdownItem>
                    <DropdownItem onClick={this.changeState.bind(this, '0')}>
                        <i className="fa fa-times attendee-response-icon-padding" />
                        {MTG_DECLINED_TXT}
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    };

    renderStatic = attendanceText => {
        return (
            <Dropdown dropup={true} isOpen={this.state.expanded} toggle={this.toggle}>
                <DropdownToggle
                    className="btn btn-sm btn-outline-secondary dropdown-toggle "
                    disabled
                >
                    <span className="pl-3">{attendanceText}</span>
                </DropdownToggle>
            </Dropdown>
        );
    };

    render() {
        const { attendance } = this.props;
        let attendanceText = MTG_PENDING_TXT;

        switch (attendance) {
            case MTG_DECLINED:
                attendanceText = MTG_DECLINED_TXT;
                break;

            case MTG_ATTENDING:
                attendanceText = MTG_ATTENDING_TXT;
                break;

            case MTG_TENTATIVE:
                attendanceText = MTG_TENTATIVE_TXT;
                break;

            default:
                attendanceText = MTG_PENDING_TXT;
                break;
        }

        if (store.meetings.filteredBy === MTG_UPCOMING) {
            return this.renderDropdown(attendanceText);
        } else {
            return this.renderStatic(attendanceText);
        }
    }
}

Attendance.propTypes = {
    instanceId: PropTypes.number,
    groupId: PropTypes.number,
    meetingId: PropTypes.number,
    attendance: PropTypes.number,
    onChange: PropTypes.func,
};

export default Attendance;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Meeting/components/AttendanceDropdown.js